import { useEffect, useState } from "react";
import {
  MaterialReactTable,
  createMRTColumnHelper,
  useMaterialReactTable,
} from "material-react-table";
import {
  Box,
  Button,
  IconButton,
  Link,
  ThemeProvider,
  Tooltip,
  createTheme,
} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { mkConfig, generateCsv, download } from "export-to-csv";
//import { darken, lighten, useTheme } from "@mui/material";
//import UseFetch from "../../customComponents/UseFetch";
//import { ADHARS, ADMIN, BASE_URL } from "../../helpers/url_helper";
// import { NotificationIcon } from "react-autoql";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EditIcon from "@mui/icons-material/Edit";
import { Delete } from "@mui/icons-material";
import MonthYearsPicker from "../../pages/partnerCommissionReport/MonthYearsPicker";
import ToastComponent from "./ToastComponent";
import { useMediaQuery, useTheme } from "@mui/material";
import { useSelector } from "react-redux";

//const columnHelper = createMRTColumnHelper();

// const columns = [
//   columnHelper.accessor("msg.Gender", {
//     header: "Gender",
//     size: 30,
//   }),
//   columnHelper.accessor("msg.Country", {
//     header: "Country",
//     size: 30,
//   }),
//   columnHelper.accessor("city", {
//     header: "City",
//     size: 30,
//   }),
//   columnHelper.accessor("country", {
//     header: "Country",
//     size: 30,
//   }),
// ];

const csvConfig = mkConfig({
  fieldSeparator: ",",
  decimalSeparator: ".",
  useKeysAsHeaders: true,
});

const CustomTable3 = ({
  columns,
  data,
  showRowAction = false,
  DataForExportAll,
  showMonthYearsPicker = false,
  onMonthYearChange,
  loading = false,
  permissionKey,
}) => {
  // this is only for month and year selector in partner Invoice
  const handleMonthYearChange = (value) => {
    if (onMonthYearChange) {
      onMonthYearChange(value); // parent components ka props hai---partner commission componets.
    }
  };
  // end

  if (!data) {
    data = [];
  }
  if (!DataForExportAll) {
    DataForExportAll = data;
  }

  //-------------logic for show export all data----------

  const rolePermissions = useSelector((state) => state.login.login.role);
  // console.log("[[[[[[[[[[[[]]]]]]]]]]]]]]]]]]]]]]]----rolepermision------",rolePermissions)
  const canExport = rolePermissions?.[permissionKey]?.export === 1;

  // console.log("=++++++++++", canExport);

  //-------------------$$----------------------------------

  // const handleDateChange = (data) => {
  //   console.log("Selected Month and Year:", data);
  // };
  //   const url=BASE_URL+ADMIN+ADHARS
  //   const [adharData]= UseFetch(url)
  // useEffect(() => {
  //   if (data) {
  //     setData1(data)
  //   }
  // }, [data]);
  // const [data1, setData1] = useState([]);

  // const theme = useTheme();
  //light or dark green
  // const baseBackgroundColor =
  //   theme.palette.mode === "dark" ? "#323c47" : "#323c47";

  const handleExportRows = (rows) => {
    const rowData = rows.map((row) => row.original);
    const csv = generateCsv(csvConfig)(rowData);
    download(csvConfig)(csv);
  };

  const handleExportData = () => {
    // const csv = generateCsv(csvConfig)(data);
    const csv = generateCsv(csvConfig)(DataForExportAll);
    download(csvConfig)(csv);
  };

  const table = useMaterialReactTable({
    columns,
    data,
    state: {
      isLoading: loading, // <--- Use this built-in prop for loading state
    },

    initialState: { density: "compact" },
    enableRowSelection: true,
    columnFilterDisplayMode: "popover",
    paginationDisplayMode: "pages",
    positionToolbarAlertBanner: "bottom",
    // enableRowActions: true,
    enableRowActions: showRowAction,
    positionActionsColumn: "last",
    enableGlobalFilter: true,
    maxSize: 100,

    muiTableHeadCellProps: {
      sx: () => ({
        background: "#DCDAFF",
        fontWeight: "normal",
      }),
    },
    // renderRowActions: ({ cell, row, table }) => [
    //   // Add your row actions here
    // ],

    renderRowActions: ({ cell, row, table }) => [
      <>
        <Box display="flex" flexDirection="row" alignItems="center">
          <Tooltip title="Edit User">
            <IconButton>
              {/* <IconButton onClick={() => handleOpen(row.original)}> */}
              <EditIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton>
              {/* <IconButton onClick={() => handleBlockUser(row.original)}> */}
              <Delete />
            </IconButton>
          </Tooltip>
        </Box>
      </>,
    ],
    renderTopToolbarCustomActions: ({ table }) => (
      <Box
        sx={{
          display: "flex",
          gap: "16px",
          padding: "8px",
          flexWrap: "wrap",
        }}
      >
        {!isMobile && canExport && (
          <Button onClick={handleExportData} startIcon={<FileDownloadIcon />}>
            Export All Data
          </Button>
        )}
        {/* <Button
          onClick={() =>
            handleExportRows(table.getPrePaginationRowModel().rows)
          }
          startIcon={<FileDownloadIcon />}
        >
          Export All Rows
        </Button>
        <Button
          onClick={() => handleExportRows(table.getRowModel().rows)}
          startIcon={<FileDownloadIcon />}
        >
          Export Page Rows
        </Button> */}
        {!isMobile && canExport && (
          <Button
            disabled={
              !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
            }
            onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
            startIcon={<FileDownloadIcon />}
          >
            Export Selected Rows
          </Button>
        )}

        {/* this is only for month and year selector in partner Invoice  */}
        {showMonthYearsPicker && (
          <MonthYearsPicker onChange={handleMonthYearChange} />
        )}
        {/* // <MonthYearPicker onChange={handleDateChange} /> */}
      </Box>
    ),

    // muiTablePaperProps: {
    //   elevation: 0,
    //   sx: {
    //     borderRadius: "0",
    //   },
    // },
    // muiTableBodyProps: {
    //   sx: (theme) => ({
    //     '& tr:nth-of-type(odd):not([data-selected="true"]):not([data-pinned="true"]) > td':
    //       {
    //         backgroundColor: darken(baseBackgroundColor, 0.2),
    //       },
    //     '& tr:nth-of-type(odd):not([data-selected="true"]):not([data-pinned="true"]):hover > td':
    //       {
    //         backgroundColor: darken(baseBackgroundColor, 0.2),
    //       },
    //     '& tr:nth-of-type(even):not([data-selected="true"]):not([data-pinned="true"]) > td':
    //       {
    //         backgroundColor: darken(baseBackgroundColor, 0.1),
    //         // backgroundColor: lighten(baseBackgroundColor, 0.1),
    //       },
    //     '& tr:nth-of-type(even):not([data-selected="true"]):not([data-pinned="true"]):hover > td':
    //       {
    //         backgroundColor: darken(baseBackgroundColor, 0.2),
    //       },
    //   }),
    // },
    // mrtTheme: (theme) => ({
    //   baseBackgroundColor: baseBackgroundColor,
    //   draggingBorderColor: theme.palette.secondary.main,
    // }),
  });

  // Create a dark theme
  // const darkTheme = createTheme({
  //   palette: {
  //     mode: "dark",
  //   },
  // });

  //light or dark green
  // const baseBackgroundColor =
  //   theme.palette.mode === 'dark'
  //     ? 'rgba(3, 44, 43, 1)'
  //     : 'rgba(244, 255, 233, 1)';

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // ✅ Mobile screen check

  return (
    // <ThemeProvider theme={darkTheme}>
    <>
      {/* */}
      <MaterialReactTable table={table} />
    </>
    // </ThemeProvider>
  );
};

export default CustomTable3;
